import { render, staticRenderFns } from "./TourReductions.vue?vue&type=template&id=49b6b7f2&"
import script from "./TourReductions.vue?vue&type=script&lang=js&"
export * from "./TourReductions.vue?vue&type=script&lang=js&"
import style0 from "./TourReductions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TourReductions.vue"
export default component.exports